import React, { useState } from "react";
import Image from "next/image";

import { SelectableImageProductCardProps } from "./types";
import IMAGES from "../constants/images";
import customImageLoader from "../../utils/imageloader";

import styles from "./productCard.module.css";

const SelectableImageProductCard = ({
  cartItem,
  onSelect,
}: // handlePlusClick,
// handleHeartClick,
SelectableImageProductCardProps): JSX.Element => {
  const [selected, setSelected] = useState<boolean>(false);

  const handleSelect = () => {
    onSelect(cartItem);
    setSelected(!selected);
  };

  return (
    <>
      <div
        className={
          !selected ? styles.basketContainer : styles.basketContainerSelected
        }
        onClick={handleSelect}
      >
        <div className={styles.basketImageContainer}>
          <Image
            src={
              cartItem.product &&
              cartItem.product.images &&
              cartItem.product.images.length > 0
                ? cartItem.product.images[0]
                : IMAGES.PRODUCTDEFAULT
            } // overrides with default image if image is null or none provided
            height={1}
            width={1}
            loading="eager"
            layout="responsive"
            alt="cartItem.product image"
            loader={customImageLoader}
          />
        </div>
      </div>
      <div className={styles.basketInfoContainer}>
        <div className={styles.basketName}>
          {cartItem?.product?.brand || cartItem?.product?.name}
        </div>
        <div className={styles.basketSize}>
          Size: {cartItem.selected_variant?.size?.name}
        </div>
      </div>
    </>
  );
};

export default SelectableImageProductCard;
